import React from 'react'
import { Container } from '../../../components'
import teams from '../../../database/team.json'

const MainContent = () => {
  return (
    <React.Fragment>
      <Container>
        <div className="py-12 lg:py-24 flex flex-wrap -mx-4">
          <div className="w-full lg:w-8/12 px-4 mx-auto">
            <div className="blog-content">
              {/* <img src="/images/bnpt_about.jpg" alt="BNPT" /> */}
              <h6>
                K-Hub Penanggulangan Terorisme dan Ekstremisme berbasis Kekerasan merupakan mekanisme antar Kementerian/Lembaga, dan Mitra Pembangunan terkait upaya-upaya penanggulangan terorisme dan ekstremisme berbasis kekerasan dengan memanfaatkan platform teknologi informasi dalam pelaksanaan koordinasi, pengawasan dan pelaporan secara akuntabel, transparan dan partisipatif.
              </h6>
              <p>
                K-Hub Penanggulangan terorisme dan ekstremisme berbasis kekerasan ini diharapkan akan memberi manfaat dalam :
              </p>
              <ol>
                <li>Meningkatkan penyelarasan kerja dan program kegiatan Pemerintah Indonesia dan mitra pembangunan dalam pencapaian agenda pembangunan nasional dalam penanggulangan terorisme dan ekstremisme berbasis kekerasan sebagaimana tercermin dalam Rencana Pembangunan Jangka Panjang, Rencana Pembangunan Jangka Menengah dan Rencana Kerja Tahunan.</li>
                <li>Mengetahui peta kegiatan/program penanggulangan terorisme dan ekstremisme berbasis kekerasan yang dilakukan oleh Pemerintah Indonesia dan mitra pembangunan.</li>
                <li>Meningkatkan efektifitas distribusi dan pembagian sumber daya dalam program upaya-upaya penanggulangan terorisme dan ekstremisme berbasis kekerasan.</li>
                <li>Membangun mekanisme berbagi informasi dalam penanggulangan terorisme dan ekstremisme berbasis kekerasan.</li>
                <li>Menampilkan perkembangan upaya penanggulangan terorisme dan ekstremisme berbasis kekerasan di Indonesia terhadap dunia internasional.</li>
                <li>Mempertimbangkan penyusunan kebijakan dan pelaksanaan program penanggulangan penanggulangan terorisme dan ekstremisme berbasis kekerasan berbasis bukti</li>
                <li>Memberikan referensi untuk menginisiasi program kolaborasi.</li>
                <li>Memberi ruang advokasi mitra pembangunan kepada Pemerintah Indonesia secara langsung.</li>
                <li>
                  Berdasarkan dari manfaat yang disebutkan sebelumnya, penerima manfaat dari K-Hub adalah:
                  <ol>
                    <li>Kementerian dan Lembaga; </li>
                    <li>Pemerintah Daerah; </li>
                    <li>Mitra pembangunan (Organisasi Masyarakat Sipil, Organisasi Internasional, Lembaga Donor); </li>
                    <li>Media </li>
                    <li>Dunia Internasional </li>
                    <li>Sektor Swasta </li>
                    <li>Publik</li>
                  </ol>
                </li>
              </ol>
            </div>
          </div>
        </div>
      </Container>
      <Container className="py-12 lg:py-24" color="#f5f5f5">
        <h4 className="text-2xl lg:text-5xl mb-8 lg:mb-16 text-center uppercase">
          Board of Trustee
        </h4>
        <div className="team flex flex-wrap -mx-4 -mb-8 lg:-mb-16">
          {teams.map((team, index) => (
            <div className="w-1/2 sm:w-4/12 md:w-3/12 px-4 mb-8 lg:mb-16 text-center" key={index}>
              <div style={{backgroundImage: `url('${team.image}')`, width: '110px', height: '110px'}} className="bg-no-repeat bg-top bg-cover mx-auto rounded rounded-full mb-5"></div>
              {/* <img src={team.image} alt={team.name} className="mb-5 mx-auto" /> */}
              <p className="lg:text-lg font-bold lg:mb-1">{team.name}</p>
              <div className="text-gray-444 text-sm">{team.title}</div>
            </div>
          ))}
        </div>
      </Container>
    </React.Fragment>
  )
}

export { MainContent }
